import api from "./api";

const subCategoryService = {
  // Get all subcategories with filtering and pagination
  getAllSubCategories: async (params = {}) => {
    const response = await api.get("/api/sub-categories", { params });
    return response.data.data || response.data;
  },

  // Get subcategory by ID
  getSubCategoryById: async (id) => {
    const response = await api.get(`/api/sub-categories/${id}`);
    return response.data.data || response.data;
  },

  // Get subcategories by category ID
  getSubCategoriesByCategoryId: async (categoryId) => {
    const response = await api.get(
      `/api/sub-categories/category/${categoryId}`
    );
    return response.data.data || response.data;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveSubCategoriesByCategoryId: async (categoryId) => {
    const response = await api.get(
      `/api/sub-categories/category/${categoryId}/active`
    );
    return response.data.data || response.data;
  },

  // Create new subcategory with file upload
  createSubCategory: async (subCategoryData, imageFile = null) => {
    const formData = new FormData();

    // Add subcategory data
    formData.append("name", subCategoryData.name);
    formData.append("description", subCategoryData.description || "");
    formData.append("category_id", subCategoryData.category_id);
    formData.append("status", subCategoryData.status || "active");

    // Add image file if provided
    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.post("/api/sub-categories", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Update subcategory with file upload
  updateSubCategory: async (id, subCategoryData, imageFile = null) => {
    const formData = new FormData();

    // Add subcategory data
    formData.append("name", subCategoryData.name);
    formData.append("description", subCategoryData.description || "");
    formData.append("category_id", subCategoryData.category_id);
    formData.append("status", subCategoryData.status || "active");

    // Add image_url if provided (for preserving existing image or handling removal)
    if (subCategoryData.image_url !== undefined) {
      formData.append("image_url", subCategoryData.image_url || "");
    }

    // Add image file if provided
    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.put(`/api/sub-categories/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Delete subcategory
  deleteSubCategory: async (id) => {
    const response = await api.delete(`/api/sub-categories/${id}`);
    return response.data.data || response.data;
  },

  // Update subcategory status
  updateSubCategoryStatus: async (id, status) => {
    const response = await api.patch(`/api/sub-categories/${id}/status`, {
      status,
    });
    return response.data.data || response.data;
  },

  // Get subcategory statistics
  getSubCategoryStats: async () => {
    const response = await api.get("/api/sub-categories/stats");
    return response.data.data || response.data;
  },
};

export default subCategoryService;
